/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cn_Android_Paywall_Benefit_BtnInputs */

const en_cn_android_paywall_benefit_btn = /** @type {(inputs: Cn_Android_Paywall_Benefit_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renew Now, Keep Your Perks`)
};

const ar_cn_android_paywall_benefit_btn = /** @type {(inputs: Cn_Android_Paywall_Benefit_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جدّد الآن واحتفظ بمزاياك`)
};

const de_cn_android_paywall_benefit_btn = /** @type {(inputs: Cn_Android_Paywall_Benefit_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt verlängern und Vorteile behalten`)
};

const es_cn_android_paywall_benefit_btn = /** @type {(inputs: Cn_Android_Paywall_Benefit_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renueva ahora y conserva tus ventajas`)
};

const fr_cn_android_paywall_benefit_btn = /** @type {(inputs: Cn_Android_Paywall_Benefit_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renouvelle maintenant, garde tes avantages`)
};

const it_cn_android_paywall_benefit_btn = /** @type {(inputs: Cn_Android_Paywall_Benefit_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rinnova ora e mantieni i vantaggi`)
};

const ja_cn_android_paywall_benefit_btn = /** @type {(inputs: Cn_Android_Paywall_Benefit_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今すぐ更新して特典を継続`)
};

const ko_cn_android_paywall_benefit_btn = /** @type {(inputs: Cn_Android_Paywall_Benefit_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`지금 갱신하고 혜택 유지하기`)
};

const pt_br_cn_android_paywall_benefit_btn = /** @type {(inputs: Cn_Android_Paywall_Benefit_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renove agora e mantenha seus benefícios`)
};

const ru_cn_android_paywall_benefit_btn = /** @type {(inputs: Cn_Android_Paywall_Benefit_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продлите сейчас и сохраните преимущества`)
};

const th_cn_android_paywall_benefit_btn = /** @type {(inputs: Cn_Android_Paywall_Benefit_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ต่ออายุตอนนี้เพื่อรับสิทธิประโยชน์ต่อไป`)
};

const tr_cn_android_paywall_benefit_btn = /** @type {(inputs: Cn_Android_Paywall_Benefit_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şimdi yenile, avantajlarını koru`)
};

const zh_cn_cn_android_paywall_benefit_btn = /** @type {(inputs: Cn_Android_Paywall_Benefit_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`立即续费，保留特权！`)
};

const zh_tw_cn_android_paywall_benefit_btn = /** @type {(inputs: Cn_Android_Paywall_Benefit_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`立即續訂，保留權益！`)
};

/**
* | output |
* | --- |
* | "Renew Now, Keep Your Perks" |
*
* @param {Cn_Android_Paywall_Benefit_BtnInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const cn_android_paywall_benefit_btn = /** @type {((inputs?: Cn_Android_Paywall_Benefit_BtnInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cn_Android_Paywall_Benefit_BtnInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cn_android_paywall_benefit_btn(inputs)
	if (locale === "ar") return ar_cn_android_paywall_benefit_btn(inputs)
	if (locale === "de") return de_cn_android_paywall_benefit_btn(inputs)
	if (locale === "es") return es_cn_android_paywall_benefit_btn(inputs)
	if (locale === "fr") return fr_cn_android_paywall_benefit_btn(inputs)
	if (locale === "it") return it_cn_android_paywall_benefit_btn(inputs)
	if (locale === "ja") return ja_cn_android_paywall_benefit_btn(inputs)
	if (locale === "ko") return ko_cn_android_paywall_benefit_btn(inputs)
	if (locale === "pt_br") return pt_br_cn_android_paywall_benefit_btn(inputs)
	if (locale === "ru") return ru_cn_android_paywall_benefit_btn(inputs)
	if (locale === "th") return th_cn_android_paywall_benefit_btn(inputs)
	if (locale === "tr") return tr_cn_android_paywall_benefit_btn(inputs)
	if (locale === "zh_cn") return zh_cn_cn_android_paywall_benefit_btn(inputs)
	return zh_tw_cn_android_paywall_benefit_btn(inputs)
});